import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { fundingSearchPrivacyToggle } from './types';

import { requestFundingSearchPrivacyToggleSuccess } from './actions';

const logger = new Logger('Saga:FundingSearch:PrivacyToggle');

export function* requestFundingSearchPrivacyToggleSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.patch,
      routerService.generate('api.funding_search_privacy_toggle', {
        fundingSearchId: action.fundingSearchId,
      }),
    );

    action.promise && action.promise.resolve();
    yield put(requestFundingSearchPrivacyToggleSuccess(action.fundingSearchId, response.data));
  } catch (error) {
    logger.error('Failed to request privacy toggle with the following error', error);
    action.promise && action.promise.reject();
  }
}

export default function* privacyToggleSaga() {
  return yield all([
    takeLatest(fundingSearchPrivacyToggle.request, requestFundingSearchPrivacyToggleSaga),
  ]);
}
